
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.979 5.104a.5.5 0 00-.52-.52l-8.52.338a.5.5 0 00-.333.853l2.677 2.677-5.657 5.657-3.399-3.399a2 2 0 00-2.828 0L.586 15.523a2 2 0 102.828 2.828l3.399-3.398 3.399 3.398a2 2 0 002.828 0l7.071-7.07 2.677 2.676a.5.5 0 00.853-.334l.338-8.52z","fill":"#809D99"}})])
          )
        }
      }
    